module.exports = __webpack_public_path__ + "img/Marek.ea08a36e.jpg";